import React, { useRef, useState } from 'react';
// import emailjs from 'emailjs-com'; // Import EmailJS
import droneImage from '../../assets/image/png/Drone Planet Store.png';
import droneimage1 from '../../assets/image/png/3 1.png';
import droneimage2 from '../../assets/image/png/2 1.png';
import droneimage3 from '../../assets/image/png/1 2.png';
import droneimage4 from '../../assets/image/png/Quote.png';
import droneimage5 from '../../assets/image/png/photo.jpg';
import droneimage6 from '../../assets/image/png/maya.jpg';
import droneimage7 from '../../assets/image/png/sid.jpg';
import teamImage from "../../assets/image/png/team-meeting.jpg";
import { toast } from "react-toastify";
import axios from 'axios';
import Autocomplete from "react-google-autocomplete";
import { fireGtagEvent } from "../../utils/gtagEvents";
// import logo from '../Image/Drone Planet Logo White.png';
import { Box, Typography, Grid, Card, CardContent, Button, CardMedia, Avatar, TextField, DialogActions, Dialog, DialogTitle, DialogContent, Stack } from '@mui/material';
 
const WhyEnterprise = () => {
  // Create a ref to the form section
  const contactFormRef = useRef(null);
  // State to manage the notification visibility
  const [showNotification, setShowNotification] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    message: ''
  });
 
  // Handle form data change
  const handleChange = (e) => {
    const { name, value } = e.target;  // Get the field name and its value
    setFormData({
      ...formData,
      [name]: value,  // Update the corresponding field in the formData state
    });
  };
 
  // const serviceID = 'service_b7px2cw';  // Your EmailJS service ID
  // const templateID = '1zVamjswRU6vHwG_c';  // Your template ID
  // const userID = '1zVamjswRU6vHwG_c';  // Your EmailJS user ID
  // Function to handle form submission
  // Function to handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    fireGtagEvent("qualify_lead");

    const { name, email, phone, message } = formData;
 
    // Validate required fields
    if (!name || !email || !phone || !message || !formData.address) {
  alert('Please select a city from the dropdown!');
  return;
}

    try {
      // Send form data to the backend API
      // const response = await axios.post(process.env.REACT_APP_API_URL + "/addDealershipData", {
      //   name,
      //   phone,
      //   email,
      //   message,
      // });
      const response = await axios.post( process.env.REACT_APP_API_URL + "/addDealershipData", {
        name: formData.name,
  phone: formData.phone,
  email: formData.email,
  address: formData.address, // 🔥 THIS WAS MISSING
  message: formData.message,
      });

      // Handle success response
      console.log('Form submitted successfully:', response.data);

      // Reset form data and close the modal after submission
      setFormData({
        name: '',
        email: '',
        phone: '',
        address: '',
        message: '',
      });
      setOpenModal(false); // Close the modal

      // Optionally, show a success message to the user
      toast.success('Form submitted successfully!');
    } catch (error) {
      // Handle error
      console.error('Error submitting form:', error);
      alert('Failed to submit form. Please try again.');
    }
  };
 
  // Function to open the modal
  const handleOpenModal = () => {
    setOpenModal(true);
  };
 
  // Function to close the modal
  const handleCloseModal = () => {
    fireGtagEvent("close_convert_lead");
    setOpenModal(false);
  };
 
  return (
    <div>
<Box
  sx={{
    minHeight: { xs: "auto", md: "90vh" },
    py: { xs: 6, sm: 8, md: 0 },
    display: "flex",
    alignItems: "center",
    backgroundImage: `
      linear-gradient(
        90deg,
        rgba(4, 22, 54, 0.85) 0%,
        rgba(4, 22, 54, 0.65) 40%,
        rgba(4, 22, 54, 0.35) 65%,
        rgba(15, 55, 130, 0.15) 100%
      ),
      url("${droneImage}")
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    px: { xs: 2, sm: 3, md: 6, lg: 8 },
  }}
>
  <Grid
    container
    spacing={{ xs: 4, sm: 5, md: 6 }}
    alignItems="center"
    maxWidth="1200px"
    mx="auto"
  >
    {/* LEFT CONTENT */}
    <Grid item xs={12} md={6}>
      <Typography
        sx={{
          fontSize: {
            xs: "1.7rem",
            sm: "2.2rem",
            md: "2.8rem",
            lg: "3.2rem",
          },
          fontWeight: 700,
          color: "#fff",
          lineHeight: 1.2,
          textAlign: { xs: "center", md: "left" },
        }}
      >
        Reach{" "}
        <Box component="span" sx={{ color: "#318dcc" }}>
          10,000+
        </Box>
        <br />
        Qualified Buyers Nationwide
      </Typography>

      <Typography
        sx={{
          mt: 2,
          fontSize: {
            xs: "0.95rem",
            sm: "1.05rem",
            md: "1.15rem",
            lg: "1.3rem",
          },
          color: "#e3f2fd",
          maxWidth: { md: 520 },
          textAlign: { xs: "center", md: "left" },
          mx: { xs: "auto", md: 0 },
        }}
      >
        Join India’s leading drone B2B platform connecting verified manufacturers
        with serious buyers across the country.
      </Typography>
    </Grid>

    {/* RIGHT FORM CARD */}
    <Grid
      item
      xs={12}
      md={6}
      display="flex"
      justifyContent={{ xs: "center", md: "flex-end" }}
    >
      <Card
        id="hero-form"
        sx={{
          width: "100%",
          maxWidth: 420,
          borderRadius: 3,
          boxShadow: {
            xs: "0 10px 30px rgba(0,0,0,0.25)",
            md: "0 20px 60px rgba(0,0,0,0.25)",
          },
        }}
      >
        <CardContent
          sx={{
            p: { xs: 3, sm: 4 },
          }}
        >
          <Typography
            fontSize={{ xs: "1.25rem", sm: "1.4rem", md: "1.5rem" }}
            fontWeight={700}
            mb={2}
            textAlign="center"
            color="#003366"
          >
            Register Now
          </Typography>

          <Stack spacing={2}>
            <TextField
              fullWidth
              label="Full Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              variant="standard"
            />

            <TextField
              fullWidth
              label="Phone Number"
              name="phone"
              value={formData.phone}
              onChange={(e) => {
                if (/^\d{0,10}$/.test(e.target.value)) handleChange(e);
              }}
              variant="standard"
            />

            <TextField
              fullWidth
              label="Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              variant="standard"
            />
            <Box>
  {/* <Typography
    sx={{
      fontSize: "0.8rem",
      color: "rgba(0,0,0,0.6)",
      mb: 0.5,
    }}
  >
    City / Address
  </Typography> */}

  <Autocomplete
    apiKey={process.env.REACT_APP_GOOGLE_KEY}
    onPlaceSelected={(place) => {
      setFormData((prev) => ({
        ...prev,
        address:
          place.formatted_address || place.name || "",
      }));
    }}
    options={{
      types: ["(cities)"],
      componentRestrictions: { country: "in" },
    }}
    placeholder="Enter your city"
    style={{
      width: "100%",
      border: "none",
      borderBottom: "1px solid rgba(0,0,0,0.42)",
      padding: "6px 0",
      fontSize: "0.95rem",
      outline: "none",
      background: "transparent",
    }}
    onFocus={(e) =>
      (e.target.style.borderBottom =
        "2px solid #003366")
    }
    onBlur={(e) =>
      (e.target.style.borderBottom =
        "1px solid rgba(0,0,0,0.42)")
    }
  />
</Box>


            <TextField
              fullWidth
              label="Message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              variant="standard"
              multiline
              rows={3}
            />

            <Button
              onClick={handleSubmit}
              variant="contained"
              fullWidth
              sx={{
                mt: 2,
                backgroundColor: "#003366",
                borderRadius: "30px",
                fontWeight: 600,
                py: 1.2,
                fontSize: "0.95rem",
                "&:hover": { backgroundColor: "#002244" },
              }}
            >
              Submit
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Grid>
  </Grid>
</Box>









 
 
 
 
      {/* Popup Modal (Dialog) for Form */}
     
 
      <Dialog
      open={openModal}
      onClose={handleCloseModal}
      maxWidth="xs"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: 2,
          marginTop: "100px",
          maxHeight: '120vh',
          backgroundColor: '#FFFFFF', // White background
          overflowY: 'auto',
        },
      }}
    >
      <DialogTitle
        sx={{
          backgroundColor: '#FFFFFF',
          color: '#003366 ',
          textAlign: 'center',
          fontSize: '1.5rem',
          fontWeight: 600,
        }}
      >
        Register Now
      </DialogTitle>
 
      <Box
        sx={{
          padding: 0,
          backgroundColor: '#FFFFFF',
          borderRadius: 2,
          maxHeight: '95vh',
          overflowY: 'auto',
        }}
      >
        {/* Name */}
        <Box padding={3}>
        <TextField
          fullWidth
          label="Full Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          variant="standard"
          sx={{
            mb: 2,
            '& .MuiInput-underline:before': { borderBottomColor: '#388e3c' }, // Default black underline
            '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: '#003366 ' }, // Green hover effect
            '& .MuiInput-underline:after': { borderBottomColor: '#003366 ' }, // Green focus effect
            '& .MuiInputLabel-root.Mui-focused': { color: '#003366 ' }, // Green label on focus
          }}
        />
 
        {/* Phone Number */}
        <TextField
          fullWidth
          label="Phone Number"
          name="phone"
          value={formData.phone}
          onChange={(e) => {
            if (/^\d{0,10}$/.test(e.target.value)) handleChange(e);
          }}
          variant="standard"
          sx={{
            mb: 2,
            '& .MuiInput-underline:before': { borderBottomColor: '#388e3c' }, // Default black underline
            '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: '#003366 ' }, // Green hover effect
            '& .MuiInput-underline:after': { borderBottomColor: '#003366 ' }, // Green focus effect
            '& .MuiInputLabel-root.Mui-focused': { color: '#003366 ' }, // Green label on focus
          }}
        />
 
        {/* Pincode */}
        <TextField
  fullWidth
  label="Email"
  name="email"
  value={formData.email}
  onChange={(e) => {
    handleChange(e);
  }}
  variant="standard"
  sx={{
    mb: 2,
    '& .MuiInput-underline:before': {
      borderBottomColor: '#388e3c', // Default underline color (Green)
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottomColor: '#003366', // Dark blue underline on hover
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#003366', // Dark blue underline on focus
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: '#003366', // Dark blue label when focused
    },
    '& .MuiInputBase-root': {
      fontSize: '1rem', // Set font size for the input
      color: '#333', // Set text color
    },
    '& .MuiInputLabel-root': {
      fontWeight: '500', // Slightly bolder font for the label
    }
  }}
/>
 
 
        {/* Address */}
        <TextField
          fullWidth
          label="Message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          variant="standard"
          sx={{
            mb: 2,
            '& .MuiInput-underline:before': { borderBottomColor: '#388e3c' }, // Default black underline
            '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: '#003366 ' }, // Green hover effect
            '& .MuiInput-underline:after': { borderBottomColor: '#003366 ' }, // Green focus effect
            '& .MuiInputLabel-root.Mui-focused': { color: '#003366 ' }, // Green label on focus
          }}
        />
</Box>
       
      </Box>
 
      {/* Dialog Actions */}
      <DialogActions sx={{ backgroundColor: '#FFFFFF'}}>
        <Button
          onClick={handleCloseModal}
          variant="text"
          sx={{
            color: '#333',
            fontWeight: 600,
            px: 3,
            '&:hover': { backgroundColor: '#f2f2f2' },
            mt:2,
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          sx={{
            backgroundColor: '#003366 ',
            color: 'white',
            borderRadius: 30,
            px: 3,
            '&:hover': { backgroundColor: '#003366 ' },
            mt:2,
          }}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
 
 
  {/* Section 4: Why Choose Us */}
<Box sx={{ py: 2, backgroundColor: 'white' }}>
  <Typography
    variant="h2"
    sx={{
      color: "#123d67",
      fontSize: '2.5rem',
      mb: 3,
      textAlign: 'center',
      fontWeight: 'bold'
    }}
  >
    What We Offer?
  </Typography>

  <Grid
    container
    spacing={4}
    sx={{ padding: '16px' }}
    justifyContent="center"
  >
    {/* Wide Range of Drones */}
    <Grid item xs={12} md={5}>
      <Card
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '430px',
          maxWidth: '330px',
          position: 'relative',
          overflow: 'hidden',
          margin: 'auto',
        }}
      >
        <CardMedia
          component="img"
          image={droneimage1}
          alt="Wide Range of Drones"
          sx={{
            height: '100%',
            width: '100%',
            objectFit: 'cover',
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 0,
          }}
        />

        <CardContent
          sx={{
            position: 'relative',
            zIndex: 1,
            color: 'white',
            padding: '16px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1 }}>
            Wide Range of Drones
          </Typography>
          <Typography variant="body2">
            High-quality consumer drones for beginners and enthusiasts.
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            Professional-grade drones for surveying, photography, and inspections.
          </Typography>
        </CardContent>
      </Card>
    </Grid>

    {/* Expert Consultations */}
    <Grid item xs={12} md={5}>
      <Card
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '430px',
          maxWidth: '330px',
          position: 'relative',
          overflow: 'hidden',
          margin: 'auto',
        }}
      >
        <CardMedia
          component="img"
          image={droneimage3}
          alt="Expert Consultations"
          sx={{
            height: '100%',
            width: '100%',
            objectFit: 'cover',
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 0,
          }}
        />

        <CardContent
          sx={{
            position: 'relative',
            zIndex: 1,
            color: 'white',
            padding: '16px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1 }}>
            Expert Consultations
          </Typography>
          <Typography variant="body2">
            Guidance for first-time buyers.
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            Advice on drone applications for various industries.
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  </Grid>
</Box>


    <Box
  sx={{
    py: { xs: 6, sm: 8, md: 10 },
    px: { xs: 2, sm: 3 },
    backgroundColor: "#ffffff",
  }}
>
  {/* Heading */}
  <Typography
    sx={{
      fontSize: { xs: "1.6rem", sm: "1.9rem", md: "2rem" },
      fontWeight: 700,
      textAlign: "center",
      mb: 1,
      color: "#0f172a",
    }}
  >
    Why Manufacturers Choose Drone Planet
  </Typography>

  <Typography
    sx={{
      fontSize: { xs: "0.9rem", sm: "0.95rem" },
      color: "#64748b",
      textAlign: "center",
      maxWidth: 620,
      mx: "auto",
      mb: { xs: 4, sm: 6 },
      lineHeight: 1.6,
    }}
  >
    Discover the advantages that make us the preferred B2B platform for
    manufacturers nationwide
  </Typography>

  {/* PROBLEM / SOLUTION */}
  <Box sx={{ maxWidth: 1200, mx: "auto" }}>
  <Grid
    container
    spacing={{ xs: 3, md: 4 }}
    mb={{ xs: 4, md: 6 }}
  >
    {/* The Problem */}
    <Grid item xs={12} md={6}>
      <Card
        sx={{
          height: "100%",
          borderRadius: 3,
          boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
        }}
      >
        <CardContent sx={{ p: { xs: 2.5, sm: 3 } }}>
          <Typography
            sx={{
              fontWeight: 600,
              color: "#2563eb",
              mb: 2,
              fontSize: { xs: "1rem", sm: "1.05rem" },
            }}
          >
            The Problem
          </Typography>

          {[
            "Limited reach to new qualified buyers and distributors",
            "High cost of traditional marketing and lead generation",
            "Time-consuming process to verify buyer credibility",
            "Difficulty in scaling business beyond local markets",
          ].map((text, i) => (
            <Typography
              key={i}
              sx={{
                fontSize: { xs: "0.88rem", sm: "0.9rem" },
                color: "#475569",
                mb: 1,
                lineHeight: 1.6,
              }}
            >
              ❌ {text}
            </Typography>
          ))}
        </CardContent>
      </Card>
    </Grid>

    {/* How We Solve It */}
    <Grid item xs={12} md={6}>
      <Card
        sx={{
          height: "100%",
          borderRadius: 3,
          boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
        }}
      >
        <CardContent sx={{ p: { xs: 2.5, sm: 3 } }}>
          <Typography
            sx={{
              fontWeight: 600,
              color: "#2563eb",
              mb: 2,
              fontSize: { xs: "1rem", sm: "1.05rem" },
            }}
          >
            How We Solve It
          </Typography>

          {[
            "Access to 10,000+ verified buyers actively seeking products",
            "Cost-effective platform with transparent pricing models",
            "Pre-verified buyers with complete business credentials",
            "Nationwide reach with local market insights and support",
          ].map((text, i) => (
            <Typography
              key={i}
              sx={{
                fontSize: { xs: "0.88rem", sm: "0.9rem" },
                color: "#475569",
                mb: 1,
                lineHeight: 1.6,
              }}
            >
              ✅ {text}
            </Typography>
          ))}
        </CardContent>
      </Card>
    </Grid>
  </Grid>
  </Box>

  {/* FEATURES GRID */}
  <Box sx={{ maxWidth: 1200, mx: "auto" }}>
  <Grid container spacing={{ xs: 3, sm: 4 }}>
    {[
      {
        title: "Verified Buyers",
        desc: "Connect with pre-screened buyers actively looking for your products and services.",
        icon: "👥",
      },
      {
        title: "Growth Analytics",
        desc: "Track performance with detailed analytics and insights to optimize strategy.",
        icon: "📈",
      },
      {
        title: "Secure Transactions",
        desc: "Enjoy peace of mind with secure payment gateway and buyer protection policies.",
        icon: "🛡️",
      },
      {
        title: "Dedicated Support",
        desc: "Get 24/7 customer support from our expert team to help you succeed.",
        icon: "🎧",
      },
      {
        title: "Nationwide Reach",
        desc: "Expand your market presence across the country with our buyer network.",
        icon: "🌍",
      },
      {
        title: "Fast Onboarding",
        desc: "Get started in minutes with our streamlined registration and verification.",
        icon: "⚡",
      },
    ].map((item, i) => (
      <Grid item xs={12} sm={6} md={4} key={i}>
        <Card
          sx={{
            height: "100%",
            borderRadius: 3,
            boxShadow: "0 10px 25px rgba(0,0,0,0.06)",
            transition: "0.3s",
            "&:hover": {
              transform: { md: "translateY(-6px)" },
              boxShadow: { md: "0 14px 35px rgba(0,0,0,0.12)" },
            },
          }}
        >
          <CardContent sx={{ p: { xs: 2.5, sm: 3 } }}>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: 2,
                backgroundColor: "#e0edff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 2,
                fontSize: "1.2rem",
              }}
            >
              {item.icon}
            </Box>

            <Typography
              fontWeight={600}
              mb={1}
              sx={{ fontSize: { xs: "0.95rem", sm: "1rem" } }}
            >
              {item.title}
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: "0.85rem", sm: "0.9rem" },
                color: "#64748b",
                lineHeight: 1.6,
              }}
            >
              {item.desc}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    ))}
  </Grid>
  </Box>
</Box>




<Box
  sx={{
    py: { xs: 6, sm: 8, md: 10 },
    px: { xs: 2, sm: 3 },
    backgroundColor: "#ffffff",
  }}
>
  <Box sx={{ maxWidth: 1200, mx: "auto" }}>
  <Grid
    container
    spacing={{ xs: 4, md: 6 }}
    alignItems="stretch"
  >
    {/* LEFT CONTENT */}
    <Grid item xs={12} md={6}>
      <Typography
        sx={{
          fontSize: { xs: "1.8rem", sm: "2.1rem", md: "2.4rem" },
          fontWeight: 700,
          color: "#0f172a",
          mb: 2,
        }}
      >
        Trusted by India's Leading Manufacturers
      </Typography>

      <Typography
        sx={{
          color: "#475569",
          fontSize: { xs: "0.95rem", md: "1rem" },
          lineHeight: 1.7,
          maxWidth: 520,
          mb: 4,
        }}
      >
        Drone Planet has revolutionized the B2B marketplace by creating a
        seamless connection between manufacturers and qualified buyers.
        Our platform has facilitated thousands of successful partnerships
        and continues to grow exponentially.
      </Typography>

      {/* STATS */}
      <Grid container spacing={{ xs: 2, sm: 3 }} mb={4}>
        {[
          { value: "500+", label: "Active Manufacturers" },
          { value: "₹500M+", label: "Total Transactions" },
          { value: "45 Days", label: "Avg. Time to First Sale" },
          { value: "87%", label: "Customer Satisfaction" },
        ].map((item, i) => (
          <Grid item xs={6} key={i}>
            <Box
              sx={{
                backgroundColor: "#f1f7ff",
                borderRadius: 3,
                p: { xs: 2, sm: 3 },
                textAlign: "center",
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: "1.4rem", sm: "1.6rem", md: "1.8rem" },
                  fontWeight: 700,
                  color: "#2563eb",
                }}
              >
                {item.value}
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "0.8rem", sm: "0.9rem" },
                  color: "#334155",
                  mt: 0.5,
                }}
              >
                {item.label}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* AWARD */}
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: 2,
          p: { xs: 2, sm: 2.5 },
          borderRadius: 3,
          backgroundColor: "#f8fafc",
          mb: 2,
        }}
      >
        <Box sx={{ color: "#2563eb", fontSize: "1.4rem" }}>🏆</Box>
        <Box>
          <Typography fontWeight={600}>
            Award-Winning Platform
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Recognized as the Best B2B Marketplace 2024 by Industry Leaders
          </Typography>
        </Box>
      </Box>

      {/* EXPERT TEAM */}
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: 2,
          p: { xs: 2, sm: 2.5 },
          borderRadius: 3,
          backgroundColor: "#f8fafc",
        }}
      >
        <Box sx={{ color: "#2563eb", fontSize: "1.4rem" }}>👥</Box>
        <Box>
          <Typography fontWeight={600}>Expert Team</Typography>
          <Typography variant="body2" color="text.secondary">
            Dedicated account managers to help you maximize your success
          </Typography>
        </Box>
      </Box>
    </Grid>

    {/* RIGHT IMAGE */}
    <Grid item xs={12} md={6}>
      <Box
        sx={{
          position: "relative",
          height: { xs: 320, sm: 420, md: "100%" },
        }}
      >
        <Box
          component="img"
          src={teamImage}
          alt="Team meeting"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: 4,
            boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
          }}
        />

        {/* FLOATING BADGE */}
        <Box
          sx={{
            position: "absolute",
            bottom: { xs: 16, sm: 24 },
            left: { xs: 16, sm: 24 },
            backgroundColor: "#1d4ed8",
            color: "#ffffff",
            px: { xs: 2, sm: 3 },
            py: { xs: 1.5, sm: 2 },
            borderRadius: 3,
            boxShadow: "0 15px 30px rgba(0,0,0,0.25)",
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "1.4rem", sm: "1.8rem" },
              fontWeight: 700,
            }}
          >
            10,000+
          </Typography>
          <Typography sx={{ fontSize: { xs: "0.75rem", sm: "0.85rem" } }}>
            Qualified Buyers Ready to Connect
          </Typography>
        </Box>
      </Box>
    </Grid>
  </Grid>

</Box>
</Box>



 
   
 
<Box
  sx={{
    position: "relative",
    minHeight: { xs: "auto", md: "100vh" },
    py: { xs: 6, md: 0 },
    backgroundImage: `url("${droneImage}")`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  {/* Dark Overlay */}
  <Box
    sx={{
      position: "absolute",
      inset: 0,
      backgroundColor: "rgba(0,0,0,0.55)",
      zIndex: 1,
    }}
  />

  {/* CONTENT */}
  <Box
    sx={{
      position: "relative",
      zIndex: 2,
      maxWidth: 1200,
      mx: "auto",
      px: { xs: 2, sm: 3, md: 8 },

      minHeight: { md: "100vh" },
      display: "flex",
      alignItems: "center",
      justifyContent: "center",

      pt: { xs: 4, md: 5 },
      pb: { xs: 4, md: 0 },
    }}
  >
    <Grid
  container
  spacing={{ xs: 4, md: 6 }}
  alignItems="center"
>
  {/* LEFT BLOCK */}
  <Grid item xs={12} md={6}>
    <Box
      sx={{
        background: "rgba(255,255,255,0.08)",
        backdropFilter: "blur(10px)",
        borderRadius: 4,
        p: { xs: 3, sm: 4 },
        boxShadow: "0 20px 40px rgba(0,0,0,0.35)",
        border: "1px solid rgba(255,255,255,0.15)",
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: "1.6rem", sm: "2rem", md: "2.6rem" },
          fontWeight: 700,
          color: "#fff",
          mb: 2,
          lineHeight: 1.2,
          textAlign: { xs: "center", md: "left" },
        }}
      >
        Why Visit Drone Planet Store?
      </Typography>

      <Stack
        spacing={1.5}
        sx={{ alignItems: { xs: "center", md: "flex-start" } }}
      >
        {[
          "Hands-on experience with the drones before you buy",
          "Expert guidance tailored to your use-case",
          "Comprehensive post-purchase support & maintenance",
        ].map((text, i) => (
          <Typography
            key={i}
            sx={{
              fontSize: { xs: "0.9rem", sm: "1rem" },
              color: "#e5e7eb",
              lineHeight: 1.6,
              textAlign: { xs: "center", md: "left" },
            }}
          >
            ✅ {text}
          </Typography>
        ))}
      </Stack>
    </Box>
  </Grid>

  {/* RIGHT BLOCK */}
  <Grid item xs={12} md={6}>
    <Box
      sx={{
        background: "rgba(255,255,255,0.08)",
        backdropFilter: "blur(10px)",
        borderRadius: 4,
        p: { xs: 3, sm: 4 },
        boxShadow: "0 20px 40px rgba(0,0,0,0.35)",
        border: "1px solid rgba(255,255,255,0.15)",
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: "1.6rem", sm: "2rem", md: "2.6rem" },
          fontWeight: 700,
          color: "#fff",
          mb: 2,
          lineHeight: 1.2,
          textAlign: { xs: "center", md: "left" },
        }}
      >
        In-Store Services of Drone Planet
      </Typography>

      <Stack
        spacing={1.5}
        sx={{ alignItems: { xs: "center", md: "flex-start" } }}
      >
        {[
          "Drone customization for specific industry needs",
          "Beginner & professional training sessions",
          "Exclusive demo days for new drone launches",
        ].map((text, i) => (
          <Typography
            key={i}
            sx={{
              fontSize: { xs: "0.9rem", sm: "1rem" },
              color: "#e5e7eb",
              lineHeight: 1.6,
              textAlign: { xs: "center", md: "left" },
            }}
          >
            ✅ {text}
          </Typography>
        ))}
      </Stack>
    </Box>
  </Grid>
</Grid>

  </Box>
</Box>




 
 
 
     
      {/* Section 5: Customer Testimonials */}
      <Box sx={{ padding: '2rem', backgroundColor: '#f5f5f5' }}>
  {/* Section Title */}
  <Typography
    variant="h4"
    sx={{
      marginBottom: '2rem',
      textAlign: 'center',
      fontWeight: 'bold',
      marginTop: '2rem',
      color: "#123d67",
    }}
  >
    What Our Customers Say
  </Typography>

  <Box sx={{ padding: 6, textAlign: 'left' }}>
    {/* Testimonials Title */}
    <Typography
      variant="h4"
      sx={{
        marginBottom: 1,
        fontWeight: 'bold',
        color: '#006400', // Dark green color
        fontSize: '1.2rem',
        letterSpacing: '3px', // Smaller size
        textAlign: { xs: 'center', sm: 'left' }, // Centered on mobile and left-aligned on larger screens
      }}
    >
      TESTIMONIALS
    </Typography>

    {/* Our Satisfied Buyers Text */}
    <Typography
      variant="h6"
      sx={{
        marginTop: 1,
        color: '#000000', // Black color
        fontSize: '1.8rem',
        fontWeight: "bold",
        textAlign: { xs: 'center', sm: 'left' }, // Centered on mobile and left-aligned on larger screens
      }}
    >
      Our Satisfied Buyers from Worldwide
    </Typography>

    {/* Box containing the testimonial cards */}
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        gap: 2,
        marginTop: 4,
        flexDirection: { xs: 'column', sm: 'row' }, // Stack on small screens
      }}
    >
      {/* Testimonial 1 */}
      <Card
        sx={{
          width: { xs: '100%', sm: '30%' }, // Full width on mobile, 30% on larger screens
          boxShadow: 3,
          height: "300px",
          position: 'relative',
          marginBottom: { xs: '2rem', sm: '0' }, // Add spacing for mobile
        }}
      >
        <Avatar
          alt="Abhishek"
          src={droneimage5} // Replace with the actual circular image path
          sx={{
            width: 100,
            height: 110,
            borderRadius: '50%',
            position: 'absolute',
            top: 20,
            left: 30,
            border: '3px solid white',
          }}
        />
        <CardMedia
          component="img"
          height="200"
          image={droneimage4} // Replace with the actual testimonial image
          alt="Testimonial 1"
          sx={{ objectFit: 'cover' }}
        />
        <CardContent sx={{ paddingBottom: 0, marginTop: -8 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 'bold',
              textAlign: 'left',
              marginLeft: "20px",
              marginBottom: "5px",
            }}
          >
            Abhishek
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontStyle: 'italic',
              color: '#555',
              textAlign: 'left',
              marginLeft: "10px",
            }}
          >
            "Amazing experience! The drones are top quality and the customer service was exceptional."
          </Typography>
        </CardContent>
      </Card>

      {/* Testimonial 2 */}
      <Card
        sx={{
          width: { xs: '100%', sm: '30%' }, // Full width on mobile, 30% on larger screens
          boxShadow: 3,
          height: "300px",
          position: 'relative',
          marginBottom: { xs: '2rem', sm: '0' }, // Add spacing for mobile
        }}
      >
        <Avatar
          alt="Mayank"
          src={droneimage6} // Replace with the actual circular image path
          sx={{
            width: 100,
            height: 110,
            borderRadius: '70%',
            position: 'absolute',
            top: 20,
            left: 30,
            border: '3px solid white',
          }}
        />
        <CardMedia
          component="img"
          height="200"
          image={droneimage4} // Replace with the actual testimonial image
          alt="Testimonial 2"
          sx={{ objectFit: 'cover' }}
        />
        <CardContent sx={{ paddingTop: 0, marginTop: -6 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 'bold',
              textAlign: 'left',
              marginLeft: "20px",
              marginBottom: "5px",
            }}
          >
            Mayank
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontStyle: 'italic',
              color: '#555',
              textAlign: 'left',
              marginLeft: "20px",
            }}
          >
            "Best drone store I’ve ever been to! Highly recommend their products and services."
          </Typography>
        </CardContent>
      </Card>

      {/* Testimonial 3 */}
      <Card
        sx={{
          width: { xs: '100%', sm: '30%' }, // Full width on mobile, 30% on larger screens
          boxShadow: 3,
          height: "300px",
          position: 'relative',
          marginBottom: { xs: '2rem', sm: '0' }, // Add spacing for mobile
        }}
      >
        <Avatar
          alt="Sidharth"
          src={droneimage7} // Replace with the actual circular image path
          sx={{
            width: 100,
            height: 110,
            borderRadius: '70%',
            position: 'absolute',
            top: 20,
            left: 30,
            border: '3px solid white',
          }}
        />
        <CardMedia
          component="img"
          height="200"
          image={droneimage4} // Replace with the actual testimonial image
          alt="Testimonial 3"
          sx={{ objectFit: 'cover' }}
        />
        <CardContent sx={{ paddingTop: 0, marginTop: -6 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 'bold',
              textAlign: 'left',
              marginLeft: "20px",
              marginBottom: "5px",
            }}
          >
            Sidharth
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontStyle: 'italic',
              color: '#555',
              textAlign: 'left',
              marginLeft: "20px",
            }}
          >
            "Incredible service! The team is very knowledgeable and helped me find the perfect drone."
          </Typography>
        </CardContent>
      </Card>
    </Box>
  </Box>
</Box>

{/* Contact section */}
<Box
  sx={{
    py: { xs: 6, md: 8 },
    px: 2,
    background: "linear-gradient(180deg, #1d4ed8 0%, #1e40af 100%)",
    textAlign: "center",
    color: "#ffffff",
  }}
>
  {/* Heading */}
  <Typography
    sx={{
      fontSize: { xs: "1.6rem", md: "2.2rem" },
      fontWeight: 700,
      mb: 1.5,
    }}
  >
    Ready to Reach 10,000+ Buyers?
  </Typography>

  {/* Subtitle */}
  <Typography
    sx={{
      fontSize: "0.95rem",
      color: "#e0e7ff",
      maxWidth: 640,
      mx: "auto",
      mb: 4,
      lineHeight: 1.6,
    }}
  >
    Join hundreds of successful manufacturers who have transformed their
    business with Drono Planet. Start connecting with qualified buyers today.
  </Typography>

  {/* Buttons */}
  <Stack
    direction={{ xs: "column", sm: "row" }}
    spacing={2}
    justifyContent="center"
  >
    <Button
      variant="contained"
      sx={{
        backgroundColor: "#ffffff",
        color: "#1e40af",
        fontWeight: 600,
        px: 4,
        py: 1.2,
        borderRadius: 2,
        "&:hover": {
          backgroundColor: "#e0e7ff",
        },
      }}
      onClick={handleOpenModal}
    >
      Get Started Now
    </Button>

    <Button
      variant="outlined"
      sx={{
        borderColor: "#ffffff",
        color: "#ffffff",
        fontWeight: 600,
        px: 4,
        py: 1.2,
        borderRadius: 2,
        "&:hover": {
          backgroundColor: "rgba(255,255,255,0.1)",
          borderColor: "#ffffff",
        },
      }}
    >
      Call Us: +91 97735 71992
    </Button>
  </Stack>
</Box>



    </div>
  );
};
export default WhyEnterprise;